/* eslint global-require:"off" */
var flatten = require('flat');

module.exports = flatten({
  title: 'Arcblock | Blockchain 3.0',
  description: 'Born for blockchain 3.0',
  keywords: 'blockchain, platform, cloud, developer, arcblock',
  blog: {
    unlockTip: 'This content is only for ABT Wallet users, please sign in to unlock remaining content'
  },
  contactForm: {
    signup: 'Signup for our newsletter',
    name: 'Your Name',
    email: 'Your Email',
    subscribe: 'Subscribe'
  },
  // menu links
  menu: {
    pricing: 'Pricing',
    learning: 'Learning',
    login: 'Sign In',
    logout: 'Sign Out',
    roadmap: 'Roadmap',
    solution: 'Solutions',
    wallet: 'Wallet',
    blocklet: 'Blocklet',
    developer: {
      'engineer-blog': 'Engineer Blog',
      'getting-started': 'Getting Started',
      description: 'Resources, documentation, tutorials and code samples for any developer project',
      overview: 'Overview',
      documentation: 'Documentation',
      github: 'GitHub',
      main: 'Developer',
      support: 'Support',
      community: 'Community',
      title: 'Welcome Home Developers',
      whitepaper: 'Whitepaper',
      workshop: 'DApps Workshop'
    },
    platform: {
      main: 'Platform',
      title: 'A Complete Blockchain Platform',
      description: 'A platform to build, manage and deploy the next generation of decentralized applications and blockchain experiences.',
      overview: 'Overview',
      pricing: 'Pricing',
      network: 'ABT Network',
      node: 'ABT Node',
      forge: 'Forge SDK',
      ocap: 'Open Chain Access Protocol',
      did: 'Decentralized Identity',
      console: 'Management Center',
      miner: 'Miners'
    },
    about: {
      main: 'About',
      title: 'About US',
      description: 'Learn more about the company, FAQs and how to partner with us.',
      overview: 'Overview',
      faq: 'FAQs',
      partner: 'Partnership'
    }
  },
  // post related
  post: {
    categories: 'Categories',
    tags: 'Tags',
    posts: 'Posts',
    postsByCategory: 'Posts in {category}',
    postsByTag: 'Posts tagged with {tag}',
    backToPosts: 'Back to Posts',
    nextPage: 'Next',
    previousPage: 'Previous',
    continueReading: 'Read More',
    viewAll: 'View All'
  },
  footer: require('./footer/en')
});